import React from 'react';
import RightChevron from '@repo/ui/src/components/Icons/RightChevron';
import { classNames } from '@repo/ui/src/utils/classNames';

interface RightArrowProps {
  className?: string;
  secondaryClass?: string;
  darkMode?: boolean;
  onImage?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
  'aria-label'?: string | null;
  arrowSize?: string;
  hidden?: boolean;
  tabIndex?: number;
  role?: string;
  asSpan?: boolean;
}

const RightArrow = ({
  className,
  secondaryClass,
  onClick,
  darkMode,
  onImage,
  arrowSize,
  tabIndex,
  hidden,
  'aria-label': label = 'next',
  asSpan = false,
}: RightArrowProps) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.(event as unknown as React.MouseEvent<HTMLButtonElement | HTMLDivElement>);
    }
  };

  const commonProps = {
    tabIndex,
    className: classNames(
      secondaryClass,
      'before:tw-hidden tw-cursor-pointer tw-min-h-fit tw-min-w-fit tw-rounded-full focus-visible:tw-outline-2 focus-visible:tw-outline-brand-200 focus-visible:tw-outline',
      !asSpan && 'tw-border-0 tw-bg-transparent',
      hidden && '!tw-hidden',
      className,
    ),
    onClick,
    onKeyDown: handleKeyDown,
    'aria-label': label ?? undefined,
  };

  if (asSpan) {
    return (
      <div {...commonProps}>
        <RightChevron darkMode={darkMode} onImage={onImage} arrowSize={arrowSize} />
      </div>
    );
  }

  return (
    <button type="button" {...commonProps}>
      <RightChevron darkMode={darkMode} onImage={onImage} arrowSize={arrowSize} />
    </button>
  );
};

export default RightArrow;
